import { Box, Divider, Paper, Stack, Typography } from "@mui/material";

import { parseStringToDate } from "~/modules/app/util/dateHelpers";
import { formatDate, formatTime } from "~/modules/app/util/formatters";

import type { ProjectStatistics_PlannerVisitFragment } from "../fragments.generated";
import { ClickThroughLink } from "./ClickThroughLink";
import { ProjectStatisticUnavailableCard } from "./ProjectStatisticUnavailableCard";

interface ProjectVisitListCardProps {
    href: string;
    hrefTitle: string;
    title: string;
    visits: ProjectStatistics_PlannerVisitFragment[];
}

export function ProjectVisitListCard({ href, hrefTitle, title, visits }: ProjectVisitListCardProps) {
    if (visits.length < 1) {
        return <ProjectStatisticUnavailableCard title={title} />;
    }

    return (
        <Paper sx={{ display: "flex", flexDirection: "column", padding: 2, rowGap: 1 }} variant="outlined">
            <Typography variant="h6" gutterBottom>
                {title}
            </Typography>
            <Stack spacing={2}>
                {visits.map(visit => {
                    const startTime = parseStringToDate(visit.startTime as string);

                    return (
                        <Box key={visit.id}>
                            <Stack direction="row" justifyContent="space-between" alignItems="center">
                                <Box>
                                    <Typography variant="subtitle1">{visit.plannerArea.name}</Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        {visit.protocol.name}
                                    </Typography>
                                </Box>

                                <Stack direction="row" columnGap={1 / 2}>
                                    <Typography>{formatDate(startTime)}</Typography>
                                    <Divider orientation="vertical" variant="fullWidth" flexItem />
                                    <Typography>{formatTime(startTime)}</Typography>
                                </Stack>
                            </Stack>
                        </Box>
                    );
                })}
            </Stack>

            <ClickThroughLink href={href} title={hrefTitle} />
        </Paper>
    );
}
